import { Box } from "@mui/material";
import { ReactNode } from "react";

import { space } from "../theme/designTokens";

type InfoSectionProps = {
  children: ReactNode;
};

export const InfoSection = ({ children }: InfoSectionProps) => {
  return (
    <Box
      sx={{
        my: `${space.sm}px`,
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        flexWrap: "wrap",
        rowGap: `${space.sm}px`,
        // Long neighbouring values must not read as one value.
        columnGap: `${space.xxl1}px`,
      }}
    >
      {children}
    </Box>
  );
};
